import { v4 as uuidv4 } from 'uuid';
import { stepCashBankCardsTravelDocumentsAndPassportsLookup as expenseLookup } from './claimCodeMapper';

function mapToParentSection() {
  return {};
}

function mapToQuestionnaire() {
  return [];
}

function getGroupId(item) {
  const selectedClaimForArray = item.selectedClaimFor
    ? (!Array.isArray(item.selectedClaimFor)) ? item.selectedClaimFor.toJS() : item.selectedClaimFor
    : [];
  return selectedClaimForArray.length > 1 ? uuidv4() : null;
}

function mapToExpenses(data) {
  const expensesSelected = !!data.whatItemsAreYouClaimingFor && typeof data.whatItemsAreYouClaimingFor.toJS === 'function'
    ? data.whatItemsAreYouClaimingFor.toJS()
    : data.whatItemsAreYouClaimingFor || [];
  const bankCardsOrTravelDocuments = expensesSelected.includes('Bank cards or travel documents') ? mapToBankCardsOrTravelDocuments(data) : [];
  const cash = expensesSelected.includes('Cash') ? mapToCash(data) : [];
  return [...bankCardsOrTravelDocuments, ...cash];
}

function mapToBankCardsOrTravelDocuments(data) {
  if (data.infoBankCardsOrTravelDocumentsItems.length < 1) {
    return [];
  }

  const expenses = [];
  const claimCode = expenseLookup.bankCardsOrTravelDocuments.claimCode;

  data.infoBankCardsOrTravelDocumentsItems.forEach(
    (item) => {
      const groupId = getGroupId(item);
      const expense = mapExpenseItem(item, data, claimCode, groupId);
      if (!!expense) {
        expenses.push(expense);
      }
    }
  );
  return expenses;
}

function mapToCash(data) {
  if (data.infoCashItems.length < 1) {
    return [];
  }
  const expenses = [];
  const claimCode = expenseLookup.cash.claimCode;

  data.infoCashItems.forEach(
    (item) => {
      const groupId = getGroupId(item);
      const expense = mapExpenseItem(item, data, claimCode, groupId);
      if (!!expense) {
        expenses.push(expense);
      }
    }
  );

  return expenses;
}

function mapExpenseItem(item, itemDate, claimCode, groupId) {
  const selectedClaimForArray = item.selectedClaimFor ? (!Array.isArray(item.selectedClaimFor)) ? item.selectedClaimFor.toJS() : item.selectedClaimFor : [];
  const claimForInsuredIds = selectedClaimForArray.map((claimFor) => claimFor.policyRoleID);
  if (!item || !item.amountClaimed || !item.currency) {
    return null;
  }
  return {
    shortDescription: `${item.descriptionOfItem}`,
    dateOfExpense: item.dateOfExpenses,
    clientCost: item.amountClaimed,
    currency: item.currency,
    rate: null,
    requestedAmount: null,
    assessorValue: item.amountClaimed,
    claimTypeCode: claimCode,
    claimForInsuredIds,
    claimForInsureds: selectedClaimForArray,
    groupId,
  };
}

export default {
  mapToParentSection,
  mapToQuestionnaire,
  mapToExpenses,
};



// WEBPACK FOOTER //
// ./app/containers/FastCover/dataMapper/stepCashBankCardsTravelDocumentsAndPassportsDataMapper.js